// Saisie de date "a la TransCAM desktop" : on tape 010181 et on obtient 01/01/1981.
// Logique unique partagee par toute l'appli (directive v-date-fr + composants) pour
// garantir le meme comportement partout (memes regles, meme pivot de siecle).

// Pivot d'annee a 2 chiffres : > 50 => 19xx, sinon 20xx (identique au desktop / a l'ancien
// formatDate de Patient.vue). Ex : 81 -> 1981, 25 -> 2025, 50 -> 2050, 51 -> 1951.
const PIVOT_SIECLE = 50;

// Formatage "au fil de la frappe" : ne garde que les chiffres (max 8) et insere les '/'
// progressivement -> "010181" devient "01/01/81", "01011981" devient "01/01/1981".
// Non destructif : une saisie partielle reste affichee telle quelle (pas de pivot ici).
export function sanitizeDateInput(raw) {
    const chiffres = String(raw == null ? "" : raw).replace(/\D/g, "").slice(0, 8);
    let out = chiffres.slice(0, 2);
    if (chiffres.length >= 3) out += "/" + chiffres.slice(2, 4);
    if (chiffres.length >= 5) out += "/" + chiffres.slice(4, 8);
    return out;
}

// Convertit une annee a 2 chiffres en annee a 4 chiffres via le pivot de siecle.
function anneeSur4(yy) {
    return yy > PIVOT_SIECLE ? 1900 + yy : 2000 + yy;
}

// Normalise vers "JJ/MM/AAAA" en appliquant le pivot de siecle et en verifiant que la
// date existe reellement (30/02, 31/04... rejetes).
// Retourne "" si l'entree est vide, null si la date est incomplete/invalide (l'appelant
// laisse alors la saisie intacte plutot que de la detruire).
export function normalizeDateFr(raw) {
    const v = String(raw == null ? "" : raw).trim();
    if (v === "") return "";

    let jj, mm, aaaa;
    if (/^\d{6}$/.test(v)) {                       // JJMMAA
        jj = v.slice(0, 2); mm = v.slice(2, 4); aaaa = anneeSur4(parseInt(v.slice(4, 6), 10));
    } else if (/^\d{8}$/.test(v)) {                // JJMMAAAA
        jj = v.slice(0, 2); mm = v.slice(2, 4); aaaa = parseInt(v.slice(4, 8), 10);
    } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(v)) {  // JJ/MM/AA
        const p = v.split("/"); jj = p[0]; mm = p[1]; aaaa = anneeSur4(parseInt(p[2], 10));
    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {  // JJ/MM/AAAA
        const p = v.split("/"); jj = p[0]; mm = p[1]; aaaa = parseInt(p[2], 10);
    } else {
        return null;
    }

    jj = parseInt(jj, 10);
    mm = parseInt(mm, 10);
    if (jj < 1 || jj > 31 || mm < 1 || mm > 12 || aaaa < 1900) return null;

    // Verifie l'existence reelle de la date (jour valide pour le mois/annee).
    const d = new Date(aaaa, mm - 1, jj);
    if (d.getFullYear() !== aaaa || d.getMonth() !== mm - 1 || d.getDate() !== jj) return null;

    return `${String(jj).padStart(2, "0")}/${String(mm).padStart(2, "0")}/${aaaa}`;
}

// True si la saisie est vide ou represente une date valide (utilisable pour la validation
// a l'enregistrement). Une saisie vide est "valide" ici (champ optionnel) ; l'obligation
// eventuelle est geree par l'appelant.
export function estDateFrValide(raw) {
    const v = String(raw == null ? "" : raw).trim();
    if (v === "") return true;
    return normalizeDateFr(v) !== null;
}
